let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("e2ujj"), load("1hkVP"), load("g5HUX"), load("9A0ig"), load("ffEVr"), load("5xtwP")]).then(() => parcelRequire('gCU3O'));